import { useRef } from 'react';
import useHistoryPagination from '../../../hooks/api_hooks/useHistoryPagination';
import useScrollToItem from '../../../hooks/ui_hooks/useScrollToItem';
import { GwDatesWrapper } from '../../_internal_date_/gwDatesWrapper';
import { Box, Text } from '../../ui-kit';
import theme from '../../ui-kit/themes/theme';
import { editCopyByReplaceString } from '../../utilities/copyFunctions';
import {
  LoyaltyProfilePointsHistoryContainer,
  LoyaltyProfilePointsHistoryDate,
  LoyaltyProfilePointsHistoryDisclaimer,
  LoyaltyProfilePointsHistoryTableRow,
  LoyaltyProfilePointsHistoryTableRowJoinColum,
  SeeMoreContainer,
  SpanDot,
  StyledChevronDownIcon
} from '../assets/styles';
import * as COPY from '../utilities/copy';

const HISTORY_TYPES = {
  referred_a_friend: 'Referred a friend',
  points_used_on_a_booking: 'Reservation',
  points_returned_from_a_cancellation: 'Canceled Booking',
  completed_stay: 'Stayed at lodge',
  sl_expire: 'Points expired'
};

// Check if number is negative or positive
function verifyIfNegative(number) {
  return number < 0;
}

// Get the color for the points based on their value and the redesign flag
function getPointsColor(item) {
  if (verifyIfNegative(item.points)) {
    return 'deepLakeBlue.100';
  }
  return 'successGreen';
}

const LoyaltyProfilePointsHistory = ({ profileId }) => {
  const { displayArray, seeMoreRows, resetAvailable, resetRows, total } = useHistoryPagination(profileId);
  const { customScrollTo } = useScrollToItem();
  const seeMore = useRef(null);
  const historyTitle = useRef(null);

  const handleSeeMore = () => {
    resetAvailable ? resetRows() : seeMoreRows();
    customScrollTo({
      ref: resetAvailable ? historyTitle : seeMore,
      behavior: 'smooth',
      block: 'end',
      delay: 500,
      custom: {
        yOffset: -380
      }
    });
  };

  return (
    <Box>
      {displayArray.length > 0 ? (
        <>
          <Text
            ref={historyTitle}
            color="deepLakeBlue.100"
            fontWeight={['heavy', 'heavy', 'heavy', 'bold']}
            lineHeight={'112%'}
            fontSize={[7, 7, 7, 4]}
            mb={[3, 3, 3, 10]}>
            {COPY.VOYAGERS_POINTS_HISTORY}
          </Text>
          <Box>
            <LoyaltyProfilePointsHistoryContainer mb={[16, 16, 16, 7]}>
              {displayArray.map(item => (
                <LoyaltyProfilePointsHistoryTableRow key={item.uuid}>
                  <LoyaltyProfilePointsHistoryTableRowJoinColum>
                    <Text color="deepLakeBlue.100" fontWeight="bold" lineHeight={18} fontSize={[1]}>
                      {HISTORY_TYPES[item.type]}
                    </Text>
                    <LoyaltyProfilePointsHistoryDate
                      color="deepLakeBlue.100"
                      fontWeight="medium"
                      lineHeight={[20]}
                      fontSize={[1]}>
                      {GwDatesWrapper.format(item.date, 'MMM DD, YYYY')}
                    </LoyaltyProfilePointsHistoryDate>
                  </LoyaltyProfilePointsHistoryTableRowJoinColum>
                  <Text color={getPointsColor(item)} fontWeight="bold" lineHeight={[18, 18, 18, 18, 20]} fontSize={[1]}>
                    {editCopyByReplaceString(
                      COPY.HISTORY_POINTS,
                      verifyIfNegative(item.points) ? item.points : `+${item.points}`,
                      '<POINTS>'
                    )}
                  </Text>
                </LoyaltyProfilePointsHistoryTableRow>
              ))}
            </LoyaltyProfilePointsHistoryContainer>
            {total && total > 5 ? (
              <SeeMoreContainer onClick={handleSeeMore} py={[0, 0, 0, 3]}>
                <Text
                  color="preciousStoneBlue.100"
                  fontWeight="bold"
                  lineHeight={[18, 18, 18, 18, 20]}
                  fontSize={[1]}
                  mr={8}
                  ref={seeMore}>
                  {resetAvailable ? COPY.SHOW_LESS : COPY.SHOW_MORE}
                </Text>
                <StyledChevronDownIcon resetAvailable={resetAvailable} />
              </SeeMoreContainer>
            ) : null}
          </Box>
        </>
      ) : null}

      <LoyaltyProfilePointsHistoryDisclaimer>
        <SpanDot width={8} height={8} mr={8} color={theme.colors.deepForestGreen[100]} />
        <Text color={'deepForestGreen.100'} fontWeight="bold" lineHeight={'150%'} fontSize={[1, 1, 1, 2]}>
          {COPY.VOYAGERS_EXPIRATION_HISTORY}
        </Text>
      </LoyaltyProfilePointsHistoryDisclaimer>
    </Box>
  );
};

export default LoyaltyProfilePointsHistory;
